import useMode from '../stores/mode';

import { NavigationToggle } from './Navigation';

function Header() {
    const mode = useMode();
    const theme = ['intro', 'item', 'index'].includes(mode.mode) ? 'light' : 'default';

    return (
        <section className={`Header ${theme}`}>
            <h1 className="Header-title">Global Diplomacy Lab</h1>

            <NavigationToggle></NavigationToggle>
        </section>
    );
}

export default Header;
